module.exports = __webpack_public_path__ + "static/media/IMG_3992 vanity low front.b01fd815.JPG";